import { Text, VFlow } from 'bold-ui'
import { CustomSelectFieldProps, SelectField } from 'components/form'
import { HLabel } from 'components/HLabel'
import { useFlags } from 'config/useFlagsContext'
import { emptyArrayOf } from 'util/array'
import { SituacaoProblemaTag } from 'view/atendimentos/detail/components/SituacaoProblemaTag'
import { Problema } from 'view/atendimentos/detail/soap/aside/types/ProblemaModel'

import { ProblemaCondicaoSelectFieldItem } from './ProblemaCondicaoSelectFieldItem'

export type ProblemaCondicaoSelectFieldProps = CustomSelectFieldProps<Problema> & {
  problemas?: ReadonlyArray<ProblemaCondicaoSelectFieldItem>
  loading?: boolean
}

export function ProblemaCondicaoSelectField(props: ProblemaCondicaoSelectFieldProps) {
  const { problemas, loading, ...rest } = props
  const { PILOTO_CID11_ENABLED } = useFlags()

  const itemToString = (item: ProblemaCondicaoSelectFieldItem) =>
    item &&
    [
      item.ciap && `${item.ciap.descricao} (${item.ciap.codigo})`,
      item.cid10 && `${item.cid10.nome} (${item.cid10.codigo})`,
      PILOTO_CID11_ENABLED && item.cid11 && `${item.cid11.nome.toUpperCase()} (${item.cid11.codigo})`,
      item.descricaoOutro,
    ]
      .filter((e) => e)
      .join(' | ')

  const renderItem = (item: ProblemaCondicaoSelectFieldItem) => (
    <VFlow vSpacing={0}>
      {item.ciap && <HLabel title={item.ciap.descricao}>({item.ciap.codigo})</HLabel>}
      {item.cid10 && <HLabel title={item.cid10.nome}>({item.cid10.codigo})</HLabel>}
      {PILOTO_CID11_ENABLED && item.cid11 && (
        <HLabel title={item.cid11.nome.toUpperCase()}>({item.cid11.codigo})</HLabel>
      )}
      <Text fontWeight='bold'>{item.descricaoOutro}</Text>
      <SituacaoProblemaTag situacao={item.situacao} />
    </VFlow>
  )

  const sortedItems = (problemas ?? emptyArrayOf<ProblemaCondicaoSelectFieldItem>()).toSorted((a, b) =>
    itemToString(a).localeCompare(itemToString(b))
  )

  return (
    <SelectField<ProblemaCondicaoSelectFieldItem>
      itemToString={itemToString}
      renderItem={renderItem}
      items={sortedItems}
      loading={loading}
      {...rest}
    />
  )
}
